export default "__VITE_ASSET__240a85d5__"